// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
}

body {
  font-family: Inter, system-ui, -apple-system, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  color: #0f172a;
  background: #f8fafc;
}

@keyframes ql-bar {
  0%,
  100% {
    opacity: 0.45;
    transform: scaleX(0.72);
  }
  50% {
    opacity: 1;
    transform: scaleX(1);
  }
}

@keyframes ql-fade {
  0%,
  100% {
    opacity: 0.55;
  }
  50% {
    opacity: 1;
  }
}

.ql-bar {
  transform-origin: left center;
  animation: ql-bar 1.1s ease-in-out infinite;
}

.ql-bar-2 {
  animation-delay: 0.15s;
}

.ql-bar-3 {
  animation-delay: 0.3s;
}

.ql-fade {
  animation: ql-fade 1.1s ease-in-out infinite;
}

@keyframes kp-spin {
  to {
    transform: rotate(360deg);
  }
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 6px;
  border: 2px solid #fff;
}

::-webkit-scrollbar-track {
  background: #f8fafc;
}

input,
button,
select {
  font-family: inherit;
}

#root {
  min-height: 100vh;
}

.kp-btn-hover:hover {
  filter: brightness(0.96);
}

.kp-row-hover:hover {
  background: #f8fafc !important;
}

.kp-menu-btn:hover {
  background: #f1f5f9;
}

.kp-danger-btn:hover {
  background: #fef2f2;
}

.kp-primary-btn:hover {
  background: #1d4ed8;
}

.kp-chip:hover {
  border-color: #93c5fd;
}

.kp-tab-scroll {
  scrollbar-width: none;
}

.kp-tab-scroll::-webkit-scrollbar {
  display: none;
}

.kp-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.14);
  outline: none;
}

.kp-search:focus {
  border-color: #2563eb;
  background: #ffffff;
  outline: none;
}

.kp-handle:hover {
  color: #64748b !important;
}

.kp-option:hover {
  background: #f1f5f9;
}

.kp-user-btn:hover {
  background: #f1f5f9;
}

.kp-cancel-btn:hover {
  background: #f8fafc;
}

.kp-add-team:hover {
  background: #1d4ed8;
}

.kp-new-tab:hover {
  background: #e2e8f0;
}

.kp-login-btn:hover {
  background: #1d4ed8;
}

.kp-pw-toggle:hover {
  background: #eff6ff;
}

/* MCP fragment (SSR via nginx SSI → #agent-mcp-host) */
.kp-agent-mcp-host {
  display: none;
}

body.kp-screen-login .kp-agent-mcp-host {
  display: block;
  width: 368px;
  max-width: 92vw;
}

.kp-mcp-integration {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.kp-mcp-integration__summary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  font-size: 12.5px;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  list-style: none;
}

.kp-mcp-integration__summary::-webkit-details-marker {
  display: none;
}

.kp-mcp-integration__body {
  padding: 0 16px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.kp-mcp-integration__hint {
  margin: 0;
  font-size: 11.5px;
  color: #64748b;
}

.kp-mcp-integration__pre {
  margin: 0;
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 8px;
  padding: 12px;
  font-size: 11px;
  line-height: 1.55;
  overflow-x: auto;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oEAAoE;EACpE,mCAAmC;EACnC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;;IAEE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qEAAqE;AACvE","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: Inter, system-ui, -apple-system, 'Segoe UI', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  color: #0f172a;\n  background: #f8fafc;\n}\n\n@keyframes ql-bar {\n  0%,\n  100% {\n    opacity: 0.45;\n    transform: scaleX(0.72);\n  }\n  50% {\n    opacity: 1;\n    transform: scaleX(1);\n  }\n}\n\n@keyframes ql-fade {\n  0%,\n  100% {\n    opacity: 0.55;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n.ql-bar {\n  transform-origin: left center;\n  animation: ql-bar 1.1s ease-in-out infinite;\n}\n\n.ql-bar-2 {\n  animation-delay: 0.15s;\n}\n\n.ql-bar-3 {\n  animation-delay: 0.3s;\n}\n\n.ql-fade {\n  animation: ql-fade 1.1s ease-in-out infinite;\n}\n\n@keyframes kp-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 6px;\n  border: 2px solid #fff;\n}\n\n::-webkit-scrollbar-track {\n  background: #f8fafc;\n}\n\ninput,\nbutton,\nselect {\n  font-family: inherit;\n}\n\n#root {\n  min-height: 100vh;\n}\n\n.kp-btn-hover:hover {\n  filter: brightness(0.96);\n}\n\n.kp-row-hover:hover {\n  background: #f8fafc !important;\n}\n\n.kp-menu-btn:hover {\n  background: #f1f5f9;\n}\n\n.kp-danger-btn:hover {\n  background: #fef2f2;\n}\n\n.kp-primary-btn:hover {\n  background: #1d4ed8;\n}\n\n.kp-chip:hover {\n  border-color: #93c5fd;\n}\n\n.kp-tab-scroll {\n  scrollbar-width: none;\n}\n\n.kp-tab-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.kp-input:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.14);\n  outline: none;\n}\n\n.kp-search:focus {\n  border-color: #2563eb;\n  background: #ffffff;\n  outline: none;\n}\n\n.kp-handle:hover {\n  color: #64748b !important;\n}\n\n.kp-option:hover {\n  background: #f1f5f9;\n}\n\n.kp-user-btn:hover {\n  background: #f1f5f9;\n}\n\n.kp-cancel-btn:hover {\n  background: #f8fafc;\n}\n\n.kp-add-team:hover {\n  background: #1d4ed8;\n}\n\n.kp-new-tab:hover {\n  background: #e2e8f0;\n}\n\n.kp-login-btn:hover {\n  background: #1d4ed8;\n}\n\n.kp-pw-toggle:hover {\n  background: #eff6ff;\n}\n\n/* MCP fragment (SSR via nginx SSI → #agent-mcp-host) */\n.kp-agent-mcp-host {\n  display: none;\n}\n\nbody.kp-screen-login .kp-agent-mcp-host {\n  display: block;\n  width: 368px;\n  max-width: 92vw;\n}\n\n.kp-mcp-integration {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.kp-mcp-integration__summary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #334155;\n  cursor: pointer;\n  list-style: none;\n}\n\n.kp-mcp-integration__summary::-webkit-details-marker {\n  display: none;\n}\n\n.kp-mcp-integration__body {\n  padding: 0 16px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.kp-mcp-integration__hint {\n  margin: 0;\n  font-size: 11.5px;\n  color: #64748b;\n}\n\n.kp-mcp-integration__pre {\n  margin: 0;\n  background: #0f172a;\n  color: #e2e8f0;\n  border-radius: 8px;\n  padding: 12px;\n  font-size: 11px;\n  line-height: 1.55;\n  overflow-x: auto;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
